import { Module, MutationTree, ActionTree, GetterTree, Mutation } from 'vuex';
import { modelRequiredCommon } from '@/models/outbounds/requiredQuick';
import { MODEL_PAYMENT } from '@/lib/outbound/usePayment';
export class RegistryState {
  public registrySender: outbound.registry.pin = {
    name: '',
    phoneNumber: '',
    jibunAddress: '',
    detailAddress: '',
    dongName: '',
    postalCode: '',
    latitude: 0,
    longitude: 0,
    phoneValidate: false,
  };
  public registryReceiver: outbound.registry.pin = {
    name: '',
    phoneNumber: '',
    jibunAddress: '',
    detailAddress: '',
    dongName: '',
    latitude: 0,
    longitude: 0,
    postalCode: '',
    phoneValidate: false,
  };
  public registryReceivers: outbound.registry.pin[] = [];
  public policy: boolean = false;
  public registryType: outbound.registry.type = 'registeredMail';

  public customFields: outbound.customFields[] = [];
  public canUsePayment: boolean = false; //결제모달 오픈가능 여부
  public registryClientComment: string = '';
  public validatePopup: boolean = false;
  public receptionTimePopup: boolean = false;
  public mailCharge: outbound.registry.chargeType = {
    charge: '-',
    chargeUuid: '',
  };
  // 결제정보
  public payment: outbound.payment = MODEL_PAYMENT();

  //유효성 검증 여부만 boolean으로 확인
  public validationInfo: required.common = new modelRequiredCommon();
}

const Mutations: MutationTree<RegistryState> = {
  updateRegistrySender(state: RegistryState, payload: outbound.registry.pin) {
    state.registrySender = payload;
  },
  updateRegistryReceiver(state: RegistryState, payload: outbound.registry.pin) {
    state.registryReceiver = payload;
  },
  updateRegistryReceivers(state: RegistryState, payload: outbound.registry.pin[]) {
    state.registryReceivers = payload;
  },
  updateRegistryPolicy(state: RegistryState, payload: boolean) {
    state.policy = payload;
  },

  updateRegistryType(state: RegistryState, payload: outbound.registry.type) {
    state.registryType = payload;
  },

  updateRegistryClientComment(state: RegistryState, payload: string) {
    state.registryClientComment = payload;
  },
  updateValidatePopup(state: RegistryState, payload: boolean) {
    state.validatePopup = payload;
  },
  updateReceptionTimePopup(state: RegistryState, payload: boolean) {
    state.receptionTimePopup = payload;
  },
  updateRegistryReceiverPhoneNumber(state: RegistryState, payload: string) {
    state.registryReceiver.phoneNumber = payload;
  },
  updateRegistrySenderPhoneNumber(state: RegistryState, payload: string) {
    state.registrySender.phoneNumber = payload;
  },
  updateRegistryCharge(state: RegistryState, payload: outbound.registry.chargeType) {
    state.mailCharge = payload;
  },
  updateValidateInfo(state: RegistryState, payload: required.common) {
    state.validationInfo = payload;
  },

  resetValidateInfo(state: RegistryState, payload: required.common) {
    state.validationInfo = payload;
  },
  updateCustomFields(state: RegistryState, payload: outbound.customFields[]) {
    state.customFields = payload;
  },
  //결제모달오픈 여부 업데이트
  updateCanUsePayment(state: RegistryState, payload: boolean) {
    state.canUsePayment = payload;
  },
  // payment(결제정보) 변경
  updatePayment(state: RegistryState, payload: vuex.outbound.updateData<outbound.payment>) {
    state.payment[payload.key] = payload.value;
  },
};

const Actions: ActionTree<RegistryState, any> = {
  updateRegistrySender({ commit }, payload: outbound.registry.pin) {
    commit('updateRegistrySender', payload);
  },
  updateRegistryReceiver({ commit }, payload: outbound.registry.pin) {
    commit('updateRegistryReceiver', payload);
  },
  updateRegistryReceivers({ commit }, payload: outbound.registry.pin[]) {
    commit('updateRegistryReceivers', payload);
  },
  updateRegistryType({ commit }, payload: string) {
    commit('updateRegistryType', payload);
  },
  updateRegistryPolicy({ commit }, payload: boolean) {
    commit('updateRegistryPolicy', payload);
  },

  updateRegistryClientComment({ commit }, payload: string) {
    commit('updateRegistryClientComment', payload);
  },
  actionValidatePopup({ commit }, payload: boolean) {
    commit('updateValidatePopup', payload);
  },
  actionReceptionTimePopup({ commit }, payload: boolean) {
    commit('updateReceptionTimePopup', payload);
  },
  updateRegistryReceiverPhoneNumber({ commit }, payload: string) {
    commit('updateRegistryReceiverPhoneNumber', payload);
  },

  updateRegistryCharge({ commit }, payload: outbound.registry.chargeType) {
    commit('updateRegistryCharge', payload);
  },
  updateValidateInfo({ commit }, payload: required.common) {
    commit('updateValidateInfo', payload);
  },

  resetValidateInfo({ commit }) {
    commit('resetValidateInfo', new modelRequiredCommon());
  },
  updateCustomFields({ commit }, payload: outbound.customFields[]) {
    commit('updateCustomFields', payload);
  },

  updateCanUsePayment({ commit }, payload: boolean) {
    commit('updateCanUsePayment', payload);
  },
  /**
   *  payment(결제수단) 변경
   */
  updatePayment({ commit }, payload: vuex.outbound.updateData<outbound.payment>) {
    commit('updatePayment', payload);
  },
};
const Getters: GetterTree<RegistryState, any> = {
  getValidateInfo: (state: RegistryState) => (): required.common => {
    return state.validationInfo;
  },
  getReceptionTimePopup: (state: RegistryState) => (): boolean => {
    return state.receptionTimePopup;
  },
  getCustomFields: (state: RegistryState) => (): outbound.customFields[] => {
    return state.customFields;
  },
  getPolicy: (state: RegistryState) => (): boolean => {
    return state.policy;
  },
  getRegistryType: (state: RegistryState) => (): outbound.registry.type => {
    return state.registryType;
  },
  getRegistryReceiverPhone: (state: RegistryState) => (): string => {
    return state.registryReceiver.phoneNumber;
  },
  getRegistryReceivers: (state: RegistryState) => (): outbound.registry.pin[] => {
    return state.registryReceivers;
  },
};

const module: Module<RegistryState, any> = {
  namespaced: true,
  state: new RegistryState(),
  mutations: Mutations,
  actions: Actions,
  getters: Getters,
};

export default module;
